import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { ImageOverrides, ImageStyles, applyImageCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: '[flxImage]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxImageStyleDirective {
  componentStyle = input<{
    style: ImageStyles
    conditionalStyles?: ImageOverrides[]
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyImageCustomStyles(
        {
          styles: this.componentStyle().style,
          conditionalStyles: this.componentStyle().conditionalStyles,
        },
        theme()
      )
      this.styleClassName.set(className)
    })
  }
}
